import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import IPage from "models/Page";
import Reducers from "types/Reducers";

interface IState {
  pages: IPage[];
  pageIndex: number;
};

const initialState:IState = {
  pages: [],
  pageIndex: -1
};

const slice = createSlice({
  name: Reducers.Pages,
  initialState,
  reducers: {
    setPages: (state, action:PayloadAction<IPage[]>) => {
      state.pages = action.payload;
    },
    setPageIndex: (state, action:PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setPageIndexByRef: (state, action:PayloadAction<string>) => {
      const pageIndex = state.pages.findIndex((page:IPage) => page.uuid === action.payload);
      state.pageIndex = pageIndex;
    }
  },
  extraReducers(builder) { },
});

export const { setPages, setPageIndex, setPageIndexByRef } = slice.actions;

export default slice.reducer;